$(document).ready(function() {

	// custom login form functionality
	$('#plat-login-form-states').on('change', function() {
		var state = $(this).val();
		var cities_options = $('#plat-login-form-cities-all option[data-state="' + state + '"]');
		$('#plat-login-form-cities option:not([value=""])').remove();
		$('#plat-login-form-cities').append(cities_options);
		$('#plat-login-form-cities option:eq(0)').prop('selected', true);
		$('#plat-login-form-field-cities').show();
		$('#plat-login-form-field-facilities').hide();
		$('#plat-login-form-option-parkchirp').hide();
		$('#plat-login-form-option-external').hide();
		$('#plat-login-form-footer').hide();
	});

	$('#plat-login-form-cities').on('change', function() {
		var city_state = $(this).val();
		var facilities_options = $('#plat-login-form-facilities-all option[data-city-state="' + city_state + '"]');
		$('#plat-login-form-facilities option:not([value=""])').remove();
		$('#plat-login-form-facilities').append(facilities_options);
		$('#plat-login-form-facilities option:eq(0)').prop('selected', true);
		$('#plat-login-form-field-facilities').show();
		$('#plat-login-form-option-parkchirp').hide();
		$('#plat-login-form-option-external').hide();
		$('#plat-login-form-footer').hide();
	});

	$('#plat-login-form-facilities').on('change', function() {
		var external = $(this).find(':selected').data('external');
		if (external === true) {
			$('#plat-login-form-option-parkchirp').hide();
			$('#plat-login-form-option-external').show();
			$('#plat-login-form-footer').hide();
		} else if (external === false) {
			$('#plat-login-form-option-external').hide();
			$('#plat-login-form-option-parkchirp').show();
			$('#plat-login-form-footer').show();
		}
	});

	if ($('#autocomplete-form').length > 0) {
		var countries = ['us', 'ca'];
		autocomplete(countries);
		initialSearchForm('monthly');
	}

	if ($('.plat-block-statistic').length > 0) {
		var statistics = $('.plat-block-statistic');
		$(statistics).each(function(index, statistic) {
			var target = $('.plat-block-statistic-number', statistic)[0];
			var end_number = $(target).attr('data-number');
			var prefix = $(target).attr('data-prefix');
			var suffix = $(target).attr('data-suffix');
			var options = {
				startVal: 0,
				decimalPlaces: 0,
				duration: 5,
				useGrouping: true,
				useEasing: true,
				prefix: prefix,
				suffix: suffix,
				enableScrollSpy: true,
				scrollSpyOnce: true
			};
			var counter = new CountUp(target, end_number, options);
		});
	}

	$('.plat-gallery-item').on('click', function(e) {
		e.preventDefault();
		var image_url = $(this).attr('href');
		var image_alt = $('img', this).attr('alt');
		var image_caption = $('.plat-gallery-item-caption', this).html();

		var modal = $($('#plat-image-modal').html());

		$('.plat-image-modal-image img', modal).attr({
			alt: image_alt,
			src: image_url,
			srcset: image_url + ', ' + image_url + ' 2x'
		});

		if (image_caption) {
			$('.plat-image-modal-caption', modal).html(image_caption);
		} else {
			$('.plat-image-modal-caption', modal).remove();
		}

		$('body').addClass('plat-modal-active').append(modal);
	});

	function plat_close_modal(modal) {
		$(modal).addClass('plat-modal-closing');
		setTimeout(function() {
			$(modal).remove();
			$('body').removeClass('plat-modal-active');
		}, 750);
	}

	// close team member modal on button click
	$('body').on('click', '.plat-modal-close', function(e) {
		e.preventDefault();
		plat_close_modal($('.plat-modal'));
	});

	// close modal on ESC key press
	$(document).on('keydown', function(e) {
		if (e.keyCode === 27) {
			plat_close_modal($('.plat-modal'));
		}
	});


});
